!function(){"use strict";
  const productPage = ".product__page";
  const formWrapperSelector = "[data-form-wrapper]";
  const headerStickySelector = "[data-header-sticky]";
  const productImagesSelector = "product-images.product__images";
  const productMediaListSelector = "[data-product-media-list]";
  const stickyClass = "is-sticky";
  const stickyFormAttribute = "data-sticky-form-enabled";
  const stickyImagesAttribute = "data-sticky-images-enabled";

  customElements.get("product-sticky") || customElements.define("product-sticky", class extends HTMLElement {
    constructor() {
      super();

      this.formWrapper = this.querySelector(formWrapperSelector);
      this.productImages = this.querySelector(productImagesSelector);
      this.productMediaList = this.querySelector(productMediaListSelector);
      this.stickyFormEnabled = this.getAttribute(stickyFormAttribute) === "true";
      this.stickyImagesEnabled = this.getAttribute(stickyImagesAttribute) === "true";
      this.stickyScrollTop = 0;
      this.scrollLastPosition = 0;
      this.stickyDefaultTop = 0;
      this.currentPoint = 0;
      this.defaultTopBottomSpacings = 30;
      this.scrollTopPosition = window.scrollY;
      this.scrollDirectionDown = true;
      this.requestAnimationSticky = null;
      this.stickyFormLoad = true;
      this.stickyFormLastHeight = null;
      this.onChangeCounter = 0;
      this.formStickyActive = false;
      this.imageStickyActive = false;
      this.scrollEvent = (event) => this.scrollEvents(event);
      this.resizeEvent = () => this.resizeEvents();
      this.stickyFormEvent = (event) => this.stickyFormEvents(event);
      this.loadEvent = () => this.stickyScrollCheck();
    }

    connectedCallback() {
      this.stickyScrollCheck();
      document.addEventListener("theme:resize", this.resizeEvent);
      window.addEventListener("load", this.loadEvent);
    }

    stickyFormEvents(event) {
      if (!this.formStickyActive) return;

      this.removeAnimationFrameSticky();
      this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(event));
    }

    scrollEvents(event) {
      this.scrollTopPosition = event.detail.position;
      this.scrollDirectionDown = event.detail.down;

      if (!this.requestAnimationSticky) {
        this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition());
      }
    }

    resizeEvents() {
      this.stickyFormLoad = true;
      this.stickyScrollCheck();
    }

    stickyScrollCheck() {
      if (!this.formWrapper) return;

      const formWrapper = this.querySelector(`${productPage} ${formWrapperSelector}`);
      const formHeight = this.formWrapper.offsetHeight;
      const mediaListHeight = this.productMediaList ? this.productMediaList.offsetHeight : 0;
      const imageHeight = this.getProductImagesHeight();
      const formShouldStick = this.stickyFormEnabled && mediaListHeight > 0 && formHeight < mediaListHeight;
      const imageShouldStick = !formShouldStick && this.stickyImagesEnabled && imageHeight > 0 && imageHeight < formHeight;

      if (window.theme.isMobile()) {
        this.setFormSticky(false);
        this.setImageSticky(false);
        return;
      }

      this.setFormSticky(formShouldStick, formWrapper);
      this.setImageSticky(imageShouldStick);
    }

    getProductImagesHeight() {
      if (!this.productImages) return 0;

      const previousAlignSelf = this.productImages.style.alignSelf;
      this.productImages.style.alignSelf = "start";
      const imageHeight = this.productImages.offsetHeight;
      this.productImages.style.alignSelf = previousAlignSelf;

      return imageHeight;
    }

    setFormSticky(enabled, formWrapper = this.formWrapper) {
      if (this.formStickyActive === enabled) {
        theme.variables.productPageSticky = enabled;
        formWrapper?.classList.toggle(stickyClass, enabled);
        return;
      }

      this.formStickyActive = enabled;
      theme.variables.productPageSticky = enabled;
      formWrapper?.classList.toggle(stickyClass, enabled);

      if (enabled) {
        this.stickyFormLoad = true;
        this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition());
        this.formWrapper.addEventListener("theme:form:sticky", this.stickyFormEvent);
        document.addEventListener("theme:scroll", this.scrollEvent);
      } else {
        this.removeAnimationFrameSticky();
        this.formWrapper.removeEventListener("theme:form:sticky", this.stickyFormEvent);
        document.removeEventListener("theme:scroll", this.scrollEvent);
        this.formWrapper.style.removeProperty("--sticky-top");
      }
    }

    setImageSticky(enabled) {
      this.imageStickyActive = enabled;
      this.productImages?.classList.toggle(stickyClass, enabled);
    }

    calculateStickyPosition(event = null) {
      if (document.documentElement.hasAttribute("data-scroll-locked") || !this.formStickyActive) {
        this.removeAnimationFrameSticky();
        return;
      }

      const hasEventDetail = Boolean(event && event.detail);
      const isAccordionChange = Boolean(hasEventDetail && event.detail.element && event.detail.element === "accordion");
      const stickyFormHeight = this.formWrapper.offsetHeight;
      const stickyMinTop = window.innerHeight - stickyFormHeight - this.defaultTopBottomSpacings;
      const scrollDifference = Math.abs(this.scrollTopPosition - this.scrollLastPosition);

      if (this.scrollDirectionDown) {
        this.stickyScrollTop -= scrollDifference;
      } else {
        this.stickyScrollTop += scrollDifference;
      }

      if (this.stickyFormLoad) {
        if (document.querySelector(headerStickySelector)) {
          const {headerHeight} = window.theme.readHeights();
          this.stickyDefaultTop = headerHeight;
        } else {
          this.stickyDefaultTop = this.defaultTopBottomSpacings;
        }

        this.stickyScrollTop = this.stickyDefaultTop;
      }

      this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, stickyMinTop), this.stickyDefaultTop);

      const stickyDistance = this.stickyScrollTop - this.currentPoint;
      this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + 0.5 * stickyDistance;
      this.formWrapper.style.setProperty("--sticky-top", `${this.currentPoint}px`);
      this.scrollLastPosition = this.scrollTopPosition;
      this.stickyFormLoad = false;

      if (isAccordionChange && this.onChangeCounter <= 10 || isAccordionChange && this.stickyFormLastHeight !== stickyFormHeight || this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky) {
        if (isAccordionChange) {
          this.onChangeCounter += 1;
        }

        if (isAccordionChange && this.stickyFormLastHeight !== stickyFormHeight) {
          this.onChangeCounter = 11;
        }

        this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(event));
      } else if (this.requestAnimationSticky) {
        this.removeAnimationFrameSticky();
      }

      this.stickyFormLastHeight = stickyFormHeight;
    }

    removeAnimationFrameSticky() {
      if (this.requestAnimationSticky) {
        cancelAnimationFrame(this.requestAnimationSticky);
        this.requestAnimationSticky = null;
        this.onChangeCounter = 0;
      }
    }

    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.resizeEvent);
      window.removeEventListener("load", this.loadEvent);
      document.removeEventListener("theme:scroll", this.scrollEvent);
      this.formWrapper?.removeEventListener("theme:form:sticky", this.stickyFormEvent);
      this.removeAnimationFrameSticky();
    }
  });
}();
